import { Vector3 } from 'three';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface SPosState {
  screenPos: {
    [name: string]: Vector3;
  };
  setScreenPos: (name: string, pos: Vector3) => void;
}

export const useSPosStore = create<SPosState>()(
  devtools(
    // persist(
    set => ({
      screenPos: {},
      setScreenPos: (name: string, pos: Vector3) => {
        set(state => {
          return {
            screenPos: {
              ...state.screenPos,
              [name]: pos,
            },
          };
        });
      },
    }),
    {
      name: 'pos-storage',
    }
    // )
  )
);
